import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-create-movement',
  templateUrl: './create-movement.component.html',
  styleUrls: ['./create-movement.component.css']
})
export class CreateMovementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
